module.exports = __webpack_public_path__ + "img/4.ffef2eda.jpg";